<template>
  <div class="coupon-amount-box">
    <AmountBox
      v-if="!isDiscount"
      :value="prizeAmountFen"
      :bit="formattedBit"
      :size="formattedSize"
      :currencyCode="formattedCurrencyCode"
      role="text"
      :aria-label="parseCurrencyAria(`${formattedCurrencyCode}${prizeAmountYuan}`, false, formattedCurrencyType)"
    ></AmountBox>
    <div class="discount-container" v-if="isDiscount"
      :aria-label="`${discountCouponRate}`"
      role="text"
      >

      <template v-if="isShowPrefix">
        <div class="discount" :style="currencyStyle" >{{ i18n('优惠') }}</div>
        <div class="amount" :style="amountStyle">{{ discountCouponRate }}</div>
        <div class="discount" :style="currencyStyle">{{ i18n('‰') }}</div>
      </template>

      <template v-else>
        <div class="amount"  :style="amountStyle">{{ discountCouponRate }}</div>
        <div class="discount" :style="currencyStyle">{{ i18n('折') }}</div>
      </template>

    </div>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AmountBox } from '@tencent/wphk-ui';
import { countDecimalPlaces, getCurrencyCodeByType, getValidCurrencyType, parseCurrencyAria, accMul, formatDiscount } from '../utils';
import { UtilsTypes } from '@tencent/wphk-act-base-types';
import { i18n, language, initLang } from '../i18n';
import { amount } from '@tencent/wphk-base-utils';
import { getAmountStyle, getUnitStyle } from '../hooks/amount-dynamic-size';
import { getSizeByAmountLen, getFen2YuanLen } from '../hooks/amount-cash-size';

@Component({
  components: {
    AmountBox,
  },
})
export default class Amount extends Vue {
  /** 币种类型 */
  @Prop({ default: UtilsTypes.CurrencyType.HKD }) public currencyType!: UtilsTypes.CurrencyType;
  /** 金额，单位元 */
  @Prop({ default: 0 }) public prizeAmountYuan!: number;
  /** 金额字体大小，视觉稿件提供的金额font-size */
  @Prop({ default: 56 }) public size!: number;
  /** 缩放比例 */
  @Prop({ default: 1 }) public zoomRatio!: number;
  /** 是否根据数值进行缩放 */
  @Prop({ default: true }) public isZoom!: boolean;
  /** 展示折扣还是金额 */
  @Prop({ default: false }) public isDiscount!: boolean;
  /** 金额，单位分，尽量都分了 不要用元了 */
  @Prop({ default: 0 }) public prizeAmountPenny!: number;
  /** 在用分的情况下小数点后面的零是否展示 */
  @Prop({ default: true }) public isDecimalPadding!: boolean;

  parseCurrencyAria = parseCurrencyAria;

  public i18n = i18n;

  /** 获取当前语言 */
  get lang() {
    return language.getLang();
  }
  /** 币种类型，默认为CurrencyType.HKD */
  get formattedCurrencyType() {
    return getValidCurrencyType(this.currencyType);
  }

  /** 币种 */
  get formattedCurrencyCode() {
    return getCurrencyCodeByType(this.currencyType);
  }

  /** 小数点 */
  get formattedBit() {
    if (this.prizeAmountPenny) {
      const formattedBit = countDecimalPlaces(this.formattedYuan);
      return formattedBit;
    }
    return countDecimalPlaces(this.prizeAmountYuan) || 0;
  }
  /** 统一变成分 */
  get prizeAmountFen(): number {
    /** 如果有传入分的话直接返回 */
    if (this.prizeAmountPenny) {
      return this.prizeAmountPenny;
    }
    /** 如果是元则用元转分 */
    return accMul(this.prizeAmountYuan || 0, 100);
  }

  /** 折扣券的折扣比例 */
  get discountCouponRate(): string {
    if (this.isDiscount) {
      return formatDiscount(Number(this.prizeAmountFen || 0), this.lang);
    }
    return '0';
  }

  /** 是否展示优惠千分比 */
  get isShowPrefix() {
    return this.prizeAmountFen < 100;
  }
  get formattedYuan(): string {
    const yuan = amount.fen2Yuan(String(this.prizeAmountPenny));
    const yuanAfterDecimalPadding = this.isDecimalPadding ? yuan : yuan.replace('.00', '').replace(/\.([1-9])0$/, '.$1');
    return yuanAfterDecimalPadding;
  }
  /** 根据金额格式化后的金额大小 */
  get formattedSize(): number {
    // 如果不进行缩放
    if (!this.isZoom) return this.size;

    // 如果进行缩放
    if (this.isDiscount) {
      return this.discountCouponRate.length < 4 ? this.size : this.size * this.zoomRatio;
    }
    return getSizeByAmountLen(getFen2YuanLen(this.prizeAmountFen)) * this.zoomRatio;
  }

  /**
     * 金额样式
     */
  get amountStyle() {
    return getAmountStyle(this.formattedSize);
  }
  /**
     * 币种样式
     */
  get currencyStyle() {
    return getUnitStyle(this.formattedSize);
  }
  created() {
    initLang(language.getLanguage());
  }
}
</script>
<style lang="less" scoped>

@import '~@wphk-ui/styles/fonts.less';

.discount-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  .prefix{
    font-size: 24/@rem;
    .amount-medium;
  }
  .amount {
    color: inherit;
    font-size: 56/@rem;
    line-height: 78 / @rem;
    .amount-medium;
  }
  .discount {
    .amount-medium;
    font-size: 24/@rem;
    color: inherit;
    margin-left: 4 / @rem;
    margin-top: 32 / @rem;
  }
}
</style>
